import axios from 'axios'
import Cookies from 'js-cookie'
import qs from 'qs'
import isPlainObject from 'lodash/isPlainObject'
import {Dialog, Toast} from "vant";
import {
    commonLogOut,
    jumpTo
} from '@/utils'
// 判断服务器是否已经返回数据
let getData = false;

const NodeRSA = require('node-rsa');
//公钥
const PRIVATE_KEY = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+B3uQOs3+YRrpE0HOEfHhUt6eJe0SjgQ5lyTd40qbVX7RXOZ7s04x3NxeMgAecym/Y0BbopGf/3hx+pClCLYKEMqjVDHLwoA0oRmb/WD1vVb+zPdhUNrhvVomI8se1XMvbjYWqbsoOvAl6PekxJq6S9GN6cAtF9Ujoh+J9luR9wIDAQAB-----END PUBLIC KEY-----'

const http = axios.create({
    baseURL: window.SITE_CONFIG['apiURL'],
    timeout: 1000 * 180,
    withCredentials: true
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {

    getData = false

    config.headers['Accept-Language'] = Cookies.get('language') || 'zh-CN'
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['Authorization'] = Cookies.get('jk_community_token')

    config.headers['X-Client-Type'] = Cookies.get("X-Client-Type");

    // 默认参数
    var defaults = {}

    if (config.loading === true) {
        Toast.clear()
        setTimeout(() => {
            // 服务器在350ms内返回数据，则不展示加载框
            if (!getData) {
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                });
            }
        }, 350)
    }

    // 防止缓存，GET请求默认带_t参数
    if (config.method === 'get') {
        config.params = {
            ...config.params,
            ...{'_t': new Date().getTime()}
        }
    }
    if (isPlainObject(config.params)) {
        config.params = {
            ...defaults,
            ...config.params
        }
    }
    if (isPlainObject(config.data)) {
        config.data = {
            ...defaults,
            ...config.data
        }
        if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
            config.data = qs.stringify(config.data)
        }
    }

    // get序列化
    config.paramsSerializer = function (params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
    }

    return config
}, error => {

    // 取消弹窗
    Toast.clear()

    return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {

    // 取消弹窗
    getData = true;
    Toast.clear()

    if (response.data.code === 401 || response.data.code === 10001) {
        // 退出登录
        commonLogOut()

        // 未登录跳转到小程序home页面
        Dialog.confirm({
            title: '提示',
            message: '登录信息过期，请重新登录',
        }).then(() => {
            // on close
            jWeixin.miniProgram.navigateTo({url: '/pages/home/home'})
        }).catch(()=>{

        });
        // jumpTo("/login")
        return Promise.reject(response.data.msg)
    }
    if (response.data.encrypt === 1) {
        const key = new NodeRSA(PRIVATE_KEY);
        response.data.data = JSON.parse(key.decryptPublic(response.data.data, 'utf8'))
        return response

    } else {
        return response
    }
}, error => {

    // 取消弹窗
    getData = true;
    Toast.clear()

    console.error(error)
    return Promise.reject(error)
})

export default http
